import { call, put } from 'redux-saga/effects'

import { fetchApi } from '../helpers/fetchApi'

import {
  fetchAvailabilitySuccess,
  fetchAvailabilityFailure
} from '../../actionCreators/availability/availabilityActionCreators'

const endpoint = '/product-api/availability-service/partNumbers'

function* availabilitySaga(action) {
  try {
    const partNumbers = action.payload.join(',')
    const url = `${endpoint}/${partNumbers}`
    const jsonData = yield call(fetchApi, url)
    const successAction = fetchAvailabilitySuccess(jsonData)
    yield put(successAction)
  } catch (error) {
    const failureAction = fetchAvailabilityFailure(error)
    yield put(failureAction)
  }
}

export { availabilitySaga, endpoint }
